export default __webpack_public_path__ + "static/media/background.e7ebe06b.jpg";